import { SheetActionType } from '../types/sheet.type';

export const setAllSheets = (payload: any) => ({
  type: SheetActionType.SET_ALL_SHEETS,
  payload: payload,
});
